import styled from 'styled-components/macro';

import { FlexAlignCenter, FlexJustifyCenter } from '../../../../../shared-styles/flex';
import colors from '../../../../../theme';
import { SMART_FILTER_TYPES } from '../../../../../constants';
import SmartFilterProblemBackground from '../../../../../assets/smart-filter-bg-problem.svg';
import SmartFilterAllLoadsBackground from '../../../../../assets/smart-filter-bg-all-loads.svg';
import SmartFilterLateLoadsBackground from '../../../../../assets/smart-filter-bg-late-loads.svg';
import SmartFilterWithinTwoHoursBackground from '../../../../../assets/smart-filter-bg-within-two-hour-loads.svg';

const palette = {
  [SMART_FILTER_TYPES.allLoads]: colors.palette.blue[100],
  [SMART_FILTER_TYPES.loadsWithProblems]: colors.palette.red[100],
  [SMART_FILTER_TYPES.lateLoads]: colors.palette.orange[100],
  [SMART_FILTER_TYPES.withinTwoHours]: (props) => props.theme.palette.custom.teal,
};

const bgUrl = {
  [SMART_FILTER_TYPES.allLoads]: SmartFilterAllLoadsBackground,
  [SMART_FILTER_TYPES.loadsWithProblems]: SmartFilterProblemBackground,
  [SMART_FILTER_TYPES.lateLoads]: SmartFilterLateLoadsBackground,
  [SMART_FILTER_TYPES.withinTwoHours]: SmartFilterWithinTwoHoursBackground,
};

const Container = styled.div.attrs(({ fieldId }) => ({
  filterColor: palette[fieldId],
  bgUrlImage: bgUrl[fieldId],
}))`
  ${FlexAlignCenter}
  width: 200px;
  height: 46px;
  padding: 0 ${({ theme }) => theme.spacing(12)};
  background-color: ${({ filterColor, isActive }) => (isActive ? filterColor : 'white')};
  background-image: url(${({ bgUrlImage }) => bgUrlImage});
  border-radius: 8px;
  color: ${({ filterColor, isActive, theme }) => (isActive ? theme.palette.white : filterColor)};
  user-select: none;
  :hover {
    cursor: pointer;
    background-color: ${({ filterColor, isActive }) => filterColor + (isActive ? '' : '33')};
  }
`;

export const Indicator = styled.div`
  ${FlexJustifyCenter}
  margin-right: ${({ theme }) => theme.spacing(8)};
`;

export const FilterLabel = styled.div`
  font-size: 12px;
  margin-right: ${({ theme }) => theme.spacing(8)};
  width: 81px;
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
`;

export const FilterCount = styled.div`
  margin-left: auto;
  font-size: 29px;
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin-right: ${({ theme }) => theme.spacing(8)};
`;

export const FilterIcon = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
})`
  flex: none;
  height: 18px;
  width: 18px;
  opacity: 0.5;
`;

export const IconWrapper = styled.div`
  ${FlexJustifyCenter}
`;

export default Container;
